import { over2, over7, under26 } from 'utils/formValidations';

export enum LeadProgram {
  ASP = 'asp',
  NP = 'np',
  CC = 'cc',
}

export const LeadProgramName: Record<LeadProgram, string> = {
  asp: 'Virtual IOP',
  np: 'NeuroPsych Evaluations',
  cc: '',
};

export const LeadProgramColor: Record<LeadProgram, string> = {
  asp: '#078189',
  np: '#6471B4',
  cc: '#292927',
};

export const LeadFooterColors: Record<LeadProgram, string> = {
  asp: '#078189',
  np: '#384275',
  cc: '#089C9C',
};

export const LeadHeaderUrl: Record<LeadProgram, string> = {
  asp: 'https://www.bendhealth.com/our-approach/acute-stabilization-program',
  np: 'https://www.bendhealth.com/our-approach/neuropsychological-evaluation',
  cc: 'https://www.bendhealth.com/refer',
};

export const LeadFooterBackgroundColors: Record<
  LeadProgram,
  { primary: string; secondary: string; text: string }
> = {
  asp: {
    primary: 'rgba(8, 156, 156, 0.2)',
    secondary: 'rgba(57, 188, 102, 0.2)',
    text: 'rgb(2, 101, 114)',
  },
  np: {
    primary: 'rgba(182, 102, 182, 0.20)',
    secondary: 'rgba(100, 113, 180, 0.20)',
    text: 'rgb(2, 101, 114)',
  },
  cc: {
    primary: 'rgba(8, 156, 156, 0.2)',
    secondary: 'rgba(57, 188, 102, 0.2)',
    text: '#292927',
  },
};

export const LeadContentFooterStyles: Record<LeadProgram, object> = {
  asp: {
    color: LeadFooterColors['asp'],
    background: `linear-gradient(
        89.99deg,
        ${LeadFooterBackgroundColors['asp'].primary} 0%,
        ${LeadFooterBackgroundColors['asp'].secondary} 99.99%
      )`,
  },
  np: {
    color: LeadFooterColors['np'],
    background: `linear-gradient(
        89.99deg,
        ${LeadFooterBackgroundColors['np'].primary} 0%,
        ${LeadFooterBackgroundColors['np'].secondary} 99.99%
      )`,
  },
  cc: {
    color: '#292927',
    background: 'rgba(211, 240, 240, 0.60)',
    borderRadius: '1rem',
    padding: '1rem 1.5rem',
  },
};

export const LeadProgramLogoColors: Record<
  LeadProgram,
  { primary: string; secondary: string }
> = {
  asp: {
    primary: '#02A0A0',
    secondary: '#2EC060',
  },
  np: {
    primary: '#B666B6',
    secondary: '#6471B4',
  },
  cc: {
    primary: '#39BC66',
    secondary: '#089C9C',
  },
};

export const LeadAgeValidator: Record<
  LeadProgram,
  {
    min: (value: any) => string | null;
    max: (value: any) => string | null;
  }
> = {
  asp: {
    min: over7,
    max: under26,
  },
  np: {
    min: over2,
    max: under26,
  },
  cc: {
    min: over2,
    max: under26,
  },
};
